// extracted by mini-css-extract-plugin
module.exports = {"tick":"Tick--tick--3NZvI"};